const envSettings = window as any;
const ENV = envSettings.VITE_APP_ENV;
export class Config {
    static VITE_APP_ENV = envSettings.VITE_APP_ENV
    static VITE_APP_SERVICE_URL = ENV == 'kubernetes' ? envSettings.VITE_APP_SERVICE_URL : import.meta.env.VITE_APP_SERVICE_URL;
    static VITE_APP_SUPERSET_URL = import.meta.env.VITE_APP_SUPERSET_URL;
    static VITE_APP_AUTH_SESSION = import.meta.env.VITE_APP_AUTH_SESSION
    static VITE_APP_IMPERSONATOR_AUTH_SESSION = import.meta.env.VITE_APP_IMPERSONATOR_AUTH_SESSION
    static VITE_APP_ACCESS_TOKEN_KEY = import.meta.env.VITE_APP_ACCESS_TOKEN_KEY
    static VITE_APP_REFRESH_TOKEN_KEY = import.meta.env.VITE_APP_REFRESH_TOKEN_KEY
    static VITE_APP_ID_TOKEN_KEY = import.meta.env.VITE_APP_ID_TOKEN_KEY
    static VITE_APP_EMAIL_KEY = import.meta.env.VITE_APP_EMAIL_KEY
    static VITE_APP_LANGUAGE_KEY = import.meta.env.VITE_APP_LANGUAGE_KEY
    static VITE_APP_CULTURE_KEY = import.meta.env.VITE_APP_CULTURE_KEY
    static VITE_APP_I18N_CONFIG_KEY = import.meta.env.VITE_APP_I18N_CONFIG_KEY
    static VITE_APP_API_URL = ENV == 'kubernetes' ? envSettings.VITE_APP_API_URL : import.meta.env.VITE_APP_API_URL;
    static VITE_APP_API_CLIENT_ID = ENV == 'kubernetes' ? envSettings.VITE_APP_API_CLIENT_ID : import.meta.env.VITE_APP_API_CLIENT_ID;
    static VITE_APP_GATEWAY_URL = ENV == 'kubernetes' ? envSettings.VITE_APP_GATEWAY_URL : import.meta.env.VITE_APP_GATEWAY_URL;
    static VITE_APP_AUTH_HASH = import.meta.env.VITE_APP_AUTH_HASH;
    static VITE_SENTRY_DSN = ENV == 'kubernetes' ? envSettings.VITE_SENTRY_DSN : import.meta.env.VITE_SENTRY_DSN;
    static VITE_SENTRY_TRACES_SAMPLES_RATE = ENV == 'kubernetes' ? envSettings.VITE_SENTRY_TRACES_SAMPLES_RATE : import.meta.env.VITE_SENTRY_TRACES_SAMPLES_RATE;
    static VITE_SENTRY_TRACE_TARGETS = ENV == 'kubernetes' ? envSettings.VITE_SENTRY_TRACE_TARGETS : import.meta.env.VITE_SENTRY_TRACE_TARGETS;
    static VITE_SOCKET_GATEWAY_URL = ENV == 'kubernetes' ? envSettings.VITE_SOCKET_GATEWAY_URL : import.meta.env.VITE_SOCKET_GATEWAY_URL;
}
